<template>
    <div class="loginMainDiv">
        <div class="wavesDiv">
            <div class="welcomeWordDiv">
                <p>嗨，你好！</p>
            </div>
            <svg class="waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 24 150 28" preserveAspectRatio="none" shape-rendering="auto">
                <defs>
                    <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
                </defs>
                <g class="parallax">
                    <use xlink:href="#gentle-wave" x="48" y="0" fill="rgba(58, 185, 254,0.7" />
                    <use xlink:href="#gentle-wave" x="48" y="3" fill="rgba(58, 185, 254,0.5)" />
                    <use xlink:href="#gentle-wave" x="48" y="5" fill="rgba(58, 185, 254,0.3)" />
                    <use xlink:href="#gentle-wave" x="48" y="7" fill="rgba(58, 185, 254,0.1)" />
                    <use xlink:href="#gentle-wave" x="48" y="9" fill="#3ab9fe" />
                </g>
            </svg>
        </div>
        <template v-if="loginType == 1">
            <van-form @submit="onSubmit" class="loginForm" :key="1">
                <van-field v-model="loginForm.userName" label="手机号" placeholder="请输入手机号" :rules="[{ required: true, message: '请输入手机号' }]" />
                <van-field v-model="loginForm.passWord" type="passWord" label="密码" placeholder="请输入密码" :rules="[{ required: true, message: '请输入密码' }]" />
                <div class="accountActiveDiv">
                    <div @click="loginType = 2">忘记密码</div>
                    <div @click="loginType = 3">注册账号</div>
                </div>
                <div style="margin: 16px;">
                    <van-button round block type="info" native-type="submit" style="font-size: 16px;">登录</van-button>
                </div>
            </van-form>
        </template>
        <template v-if="loginType == 2">
            <van-form @submit="onSubmit" class="loginForm" :key="2">
                <van-field v-model="forgetForm.userName" label="手机号" placeholder="请输入手机号" :rules="[{ required: true, message: '请输入手机号' }]" />
                <van-field v-model="forgetForm.verificationCode" center clearable label="短信验证码" placeholder="请输入短信验证码" :rules="[{ required: true, message: '请输入短信验证码' }]" style="padding: 6px 6px 6px 16px;">
                    <template #button>
                        <van-button round block native-type="button" size="small" type="primary" :disabled="countdownSecond > 0 ? true : false" @click="getVerifyCode(forgetForm.userName);">{{countdownSecond > 0 ? (countdownSecond + '秒后重新发送') : '发送验证码'}}</van-button>
                    </template>
                </van-field>
                <van-field v-model="forgetForm.newPassWord" type="passWord" label="新密码" placeholder="请输入新密码" :rules="[{ required: true, message: '请输入新密码' }]" />
                <van-field v-model="forgetForm.confirmPassWord" type="passWord" label="确认密码" placeholder="请输入确认密码" :rules="[{ required: true, message: '请输入确认密码' }]" />
                <div style="margin: 16px;display: flex;">
                    <van-button round block native-type="button" @click="loginType = 1">返回登录</van-button>
                    <van-button round block type="info" native-type="submit" style="margin-left: 20px;">确认修改</van-button>
                </div>
            </van-form>
        </template>
        <template v-if="loginType == 3">
            <van-form @submit="onSubmit" class="loginForm" :key="3">
                <van-field v-model="registerForm.stuName" label="姓名" placeholder="请输入姓名" :rules="[{ required: true, message: '请输入姓名' }]" />
                <van-field v-model="registerForm.userName" label="手机号" placeholder="请输入手机号" :rules="[{ required: true, message: '请输入手机号' }]" />
                <van-field v-model="registerForm.verificationCode" center clearable label="短信验证码" placeholder="请输入短信验证码" :rules="[{ required: true, message: '请输入短信验证码' }]" style="padding: 6px 6px 6px 16px;">
                    <template #button>
                        <van-button round block native-type="button" size="small" type="primary" :disabled="countdownSecond > 0 ? true : false" @click="getVerifyCode(registerForm.userName);">{{countdownSecond > 0 ? (countdownSecond + '秒后重新发送') : '发送验证码'}}</van-button>
                    </template>
                </van-field>
                <van-field v-model="registerForm.passWord" type="passWord" label="密码" placeholder="请输入密码" :rules="[{ required: true, message: '请输入密码' }]" />
                <div style="margin: 16px;display: flex;">
                    <van-button round block native-type="button" @click="loginType = 1">返回登录</van-button>
                    <van-button round block type="info" native-type="submit" style="margin-left: 20px;">注册</van-button>
                </div>
            </van-form>
        </template>
    </div>
</template>

<script>
    export default {
        name: 'Login',
        data() {
            return {
                loginType: 1,
                loginForm: {
                    userName: null,
                    passWord: null,
                },
                forgetForm: {
                    userName: null,
                    newPassWord: null,
                    confirmPassWord: null,
                    verificationCode: null,
                },
                registerForm: {
                    stuName: null,
                    userName: null,
                    passWord: null,
                    verificationCode: null,
                },
                countdownSecond: 0,
                countdown: null,
            };
        },
        watch: {},
        created() {
            var that = this;
        },
        mounted() {
            var that = this;
        },
        methods: {
            stuUserLogin() {
                var that = this;

                var url = that.globalAPI.mainApi + 'stu/login/stuUserLogin';

                var postData = {
                    data: {
                        userName: that.loginForm.userName,
                        passWord: that.loginForm.passWord,
                    },
                };

                postData = that.qs.parse(postData);

                that.axios
                    .post(url, postData)
                    .then(function (response) {
                        if (response.data.code == 1) {
                            that.$toast.success('登录成功');
                            var userInfo = response.data.data;
                            localStorage.setItem(
                                'userInfoSession',
                                JSON.stringify(userInfo)
                            );
                            that.$store.commit('setUserInfoSession');
                            that.$nextTick(() => {
                                that.routeTo('');
                            });
                        } else {
                            that.$toast.fail(response.data.msg);
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            addStuLogin() {
                var that = this;

                var url = that.globalAPI.mainApi + 'stu/login/addStuLogin';

                var postData = {
                    data: {
                        stuName: that.registerForm.stuName,
                        userName: that.registerForm.userName,
                        passWord: that.registerForm.passWord,
                        verificationCode: that.registerForm.verificationCode,
                    },
                };

                postData = that.qs.parse(postData);

                that.axios
                    .post(url, postData)
                    .then(function (response) {
                        if (response.data.code == 1) {
                            that.$toast.success('注册成功');
                            that.loginType = 1;
                        } else {
                            that.$toast.fail(response.data.msg);
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            forgetPassWord() {
                var that = this;

                var url = that.globalAPI.mainApi + 'stu/login/forgetPassWord';

                var postData = {
                    data: {
                        userName: that.forgetForm.userName,
                        newPassWord: that.forgetForm.newPassWord,
                        confirmPassWord: that.forgetForm.confirmPassWord,
                        verificationCode: that.forgetForm.verificationCode,
                    },
                };

                postData = that.qs.parse(postData);

                that.axios
                    .post(url, postData)
                    .then(function (response) {
                        if (response.data.code == 1) {
                            that.$toast.success('修改成功');
                            that.loginType = 1;
                        } else {
                            that.$toast.fail(response.data.msg);
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getVerifyCode(phone) {
                var that = this;

                var url = that.globalAPI.mainApi + 'syscaptcha/getVerifyCode';

                var postData = {
                    data: {
                        phone: phone,
                    },
                };

                postData = that.qs.parse(postData);

                that.axios
                    .post(url, postData)
                    .then(function (response) {
                        if (response.data.code == 1) {
                            that.$toast.success(response.data.msg);
                            that.countdownActive(60);
                        } else {
                            that.$toast.fail(response.data.msg);
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            countdownActive(second) {
                var that = this;
                if (that.countdown) {
                    that.countdownSecond = 0;
                    clearInterval(that.countdown);
                    that.countdown = null;
                }
                that.countdownSecond = second;
                that.countdown = setInterval(() => {
                    if (that.countdownSecond > 0) {
                        that.countdownSecond--;
                    } else {
                        that.countdownSecond = 0;
                        clearInterval(that.countdown);
                        that.countdown = null;
                    }
                }, 1000);
            },
            routeTo(url, query) {
                this.$router.push({
                    path: '/' + url,
                    query: query,
                });
            },
            onSubmit() {
                var that = this;
                if (that.loginType == 1) {
                    that.stuUserLogin();
                }
                if (that.loginType == 2) {
                    that.forgetPassWord();
                }
                if (that.loginType == 3) {
                    that.addStuLogin();
                }
            },
        },
    };
</script>

<style scoped>
    .loginMainDiv {
        width: 100%;
        height: 100%;
    }

    .loginMainDiv .wavesDiv {
        position: relative;
        width: 100%;
        height: 240px;
        background: #3ab9fe;
        box-sizing: border-box;
    }

    .loginMainDiv .welcomeWordDiv {
        width: 100%;
        max-height: 150px;
        color: #fff;
        font-size: 18px;
        text-align: left;
        line-height: 30px;
        margin: 0 auto;
        position: absolute;
        top: 50px;
        overflow: hidden;
    }

    .loginMainDiv .welcomeWordDiv p {
        width: 90%;
        margin: 0 auto;
    }

    .loginMainDiv .waves {
        margin-top: 200px;
        position: relative;
        width: 100%;
        height: 40px;
        max-height: 40px;
        background: #f2f2f2;
        transform: rotate(180deg);
        -ms-transform: rotate(180deg);
        -moz-transform: rotate(180deg);
        -webkit-transform: rotate(180deg);
        -o-transform: rotate(180deg);
    }

    .loginMainDiv .parallax > use {
        animation: move-forever 25s cubic-bezier(0.55, 0.5, 0.45, 0.5) infinite;
    }

    .loginMainDiv .parallax > use:nth-child(1) {
        animation-delay: -2s;
        animation-duration: 7s;
    }

    .loginMainDiv .parallax > use:nth-child(2) {
        animation-delay: -3s;
        animation-duration: 10s;
    }

    .loginMainDiv .parallax > use:nth-child(3) {
        animation-delay: -4s;
        animation-duration: 13s;
    }

    .loginMainDiv .parallax > use:nth-child(4) {
        animation-delay: -5s;
        animation-duration: 20s;
    }

    @keyframes move-forever {
        0% {
            transform: translate3d(-90px, 0, 0);
        }
        100% {
            transform: translate3d(85px, 0, 0);
        }
    }

    .loginMainDiv .loginForm {
        margin-top: 50px;
    }

    .loginMainDiv .loginForm .van-cell {
        margin: 10px auto;
        width: 90%;
        border-radius: 24px;
    }

    .loginMainDiv .accountActiveDiv {
        width: 100%;
        height: 50px;
        line-height: 50px;
        display: flex;
        justify-content: space-between;
        padding: 10px 16px;
        box-sizing: border-box;
        text-decoration: underline;
    }
</style>



// WEBPACK FOOTER //
// src/views/Login.vue